import { useFormat } from 'Services/localize/format'
import {
    DiscountContract,
    DiscountGetDiscountType,
    DiscountType,
    OrderDiscountContract,
    OrderDiscountType,
    VoidCompReasonModel,
} from 'models'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const usePosNameFormat = () => {
    const { currency } = useFormat()
    const { t } = useTranslation()

    const getCompName = useCallback(
        (voidComp: VoidCompReasonModel) => {
            return `${t('quick_sell.label.comp')} ${
                voidComp.isPercentage
                    ? `${voidComp.value ?? 0}%`
                    : currency(voidComp.value ?? 0)
            } ${t('quick_sell.label.off')}`
        },
        [currency, t],
    )
    const getCompDescription = useCallback((voidComp: VoidCompReasonModel) => {
        return (
            `${voidComp.name ?? ''}` +
            (voidComp.note ? ` - ${voidComp.note}` : '')
        )
    }, [])
    const getVoidOrderFormat = useCallback(
        (voidComp: VoidCompReasonModel) => {
            return t('quick_sell.label.void_order', {
                reason: voidComp?.name,
                note: voidComp?.note ? ` - ${voidComp?.note}` : '',
            })
        },
        [t],
    )

    const getDiscountName = useCallback(
        (
            discount: Pick<
                DiscountContract,
                'name' | 'type' | 'getAtDiscountType' | 'value'
            >,
        ) => {
            return discount.type === DiscountType.BuyXGetY
                ? `promotion (${discount.name})`
                : discount.name ||
                      `Discount ${
                          discount.type === DiscountType.Percentage ||
                          discount.getAtDiscountType ===
                              DiscountGetDiscountType.Percentage
                              ? `${discount.value ?? 0}%`
                              : currency(discount.value ?? 0)
                      } ${t('quick_sell.label.off')}`
        },
        [currency, t],
    )
    const getOrderDiscountName = useCallback(
        (
            discount: Pick<
                OrderDiscountContract,
                | 'orderDiscountType'
                | 'isPercentageDiscount'
                | 'discountValue'
                | 'discountName'
            >,
        ): string =>
            discount.orderDiscountType === OrderDiscountType.Comp
                ? `${t('quick_sell.label.comp')} ${
                      discount.isPercentageDiscount
                          ? `${discount.discountValue ?? 0}%`
                          : currency(discount.discountValue ?? 0)
                  } ${t('quick_sell.label.off')}`
                : discount.discountName ??
                  (discount.orderDiscountType === OrderDiscountType.RedeemPoint
                      ? 'Point Redeem Discount '
                      : `${t('quick_sell.label.discount')} ${
                            discount.isPercentageDiscount
                                ? `${discount.discountValue ?? 0}%`
                                : currency(discount.discountValue ?? 0)
                        }`),
        [currency, t],
    )
    return {
        getCompName,
        getCompDescription,
        getVoidOrderFormat,
        getDiscountName,
        getOrderDiscountName,
    }
}

export default usePosNameFormat
